import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const OutstandingTimesheetsAllReducer = (
    state = {
        ...FormActionReducer.defaultPageState(),
        ...FormActionReducer.defaultSearchOptions("WeekEnding", 10),
        ...FormActionReducer.defaultRecordState()
    },
    action) => {

    if (action.scope === ScopeConstants.OUTSTANDING_TIMESHEET_ALL) {
        return FormActionReducer.reduce(action, state)
    }

    return state
}